export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
};

export const formatItemCount = (count: number): string => {
  return count === 1 ? '1 item' : `${count} items`;
};

export const formatDate = (date: number): string => {
  const dateObj = new Date(date);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(dateObj);
};

/**
 * Formats the given id into JYZ/AAA-BBBB where AAA is the first 3 characters
 * and BBBB is the remaining 4 characters.
 *
 * @param {string} id - The id to format.
 * @returns {string} The formatted id.
 */
export const formatOrderId = (id: string): string => {
  // split id into 3+4 chunks separated by a dash
  const formatted = `${id.slice(0, 3)}-${id.slice(3)}`;
  return `JYZ/${formatted.toUpperCase()}`;
};

// The reverse of formatOrderId
/**
 * Parses the given formatted id into AAA-BBBB where AAA is the first 3 characters
 * and BBBB is the remaining 4 characters.
 *
 * @param {string} formattedId - The formatted id to parse.
 * @returns {string} The parsed id.
 */
export const parseOrderId = (formattedId: string): string => {
  // Remove the prefix "JYZ/"
  const withoutPrefix = formattedId.replace(/^JYZ\//, '');

  // Remove the dash and lowercase everything
  return withoutPrefix.replace('-', '').toLowerCase();
};
